import React from 'react';

export const IsReadOnlyModeContext = React.createContext<boolean>(false);

export default function useIsReadOnlyMode(): boolean {
  return React.useContext(IsReadOnlyModeContext);
}
